import DOMPurify from "dompurify";
import QRCode from 'qrcode';
const customizationService = {
  getPLeaderLabel(cityid) {
    switch (cityid) {
      case 4:
        return "BOMTE";
      case 1001:
          return "BRGY COORDINATOR";
      case 2001:
          return "TOP LEADER";
      case 1003:
          return "LEADER";
      case 1005:
          return "BRGY LEADER";
      case 6:
          return "BARANGAY MANAGER"; 
      case 5:
          return "BCS"; 
      case 3:
      case 7:
        return "BCC";
      case 2:
        return "DISTRICT LEADER";
      default:
        return "PRINCIPAL";
    }
  },
  getGLeaderLabel(cityid) {
    switch (cityid) {
      case 2001:
          return "HEAD LEADER";
      case 5:
          return "BCM"; 
      case 2:
          return "BCC"; 
      default:
        return "G-LEADER";
    }
  },
  getMunicipalitiesByDistrict(district){
    if(district==="4"){
      return [
        { value: 1, label: 'PALOMPON', description: 'Scanner App For Palompon' },
        { value: 2, label: 'ALBUERA', description: 'Scanner App For Albuera' },
        { value: 3, label: 'KANANGA', description: 'Scanner App For Kananga' },
        { value: 4, label: 'ORMOC', description: 'Scanner App For Ormoc' },
        { value: 5, label: 'ISABEL', description: 'Scanner App For Isabel' },
        { value: 6, label: 'MATAG-OB', description: 'Scanner App For Matag-ob' },
        { value: 7, label: 'MERIDA', description: 'Scanner App For Merida' },
      ];
    }
    else if(district==="3"){
      return [
        { value: 1001, label: 'LEYTE', description: 'Scanner App For Leyte, Leyte' },
        { value: 1003, label: 'VILLABA', description: 'Scanner App For Villaba, Leyte' },
        { value: 1004, label: 'CALUBIAN', description: 'Scanner App For Calubian, Leyte' },
        { value: 1005, label: 'TABANGO', description: 'Scanner App For Tabango, Leyte' },
      ];
    }
    else{
      return [
        { value: 2001, label: 'BIÑAN', description: 'Scanner App For Biñan, Laguna' },
      ];
    }
  },
  getLabelByType(cityid,type){
    switch(type){
      case "pleaders":
        return this.getPLeaderLabel(cityid)+'S';
      case "gleaders":
        return this.getPLeaderLabel(cityid)+'S';
      case "leaders":
        return this.getLeaderLabel(cityid)+'S';
      case "subleaders":
        return this.getSubLeaderLabel(cityid)+'S';
      default:
        return type.toUpperCase();
      }
  },
  getSingularLabelByType(cityid,type){
    switch(type){
      case "BOMTE":
        return this.getPLeaderLabel(cityid);
      case "LEADER":
        return this.getLeaderLabel(cityid);
      case "SUB-LEADER":
        return this.getSubLeaderLabel(cityid);
      case "G-LEADER":
          return this.getGLeaderLabel(cityid);
      default:
        return type?.toUpperCase();
      }
  },
  getSingularLabelByTypeOrDefault(cityid,type){
    switch(type){
      case "BOMTE":
        return this.getPLeaderLabel(cityid);
      case "LEADER":
        return this.getLeaderLabel(cityid);
      case "SUB-LEADER":
        return this.getSubLeaderLabel(cityid);
      case "G-LEADER":
        return this.getGLeaderLabel(cityid);
      case null:
      case "":
        return "MEMBER";
      default:
        return type?.toUpperCase();
      }
  },

  getVoterTypesByCity(cityid){
    return [
      {code: "",label: ""},
      {code: "=G-LEADER",label: this.getGLeaderLabel(cityid)},
      {code: "=BOMTE",label: this.getPLeaderLabel(cityid)},
      {code: "=LEADER",label: this.getLeaderLabel(cityid)},
      {code: "=SUB-LEADER",label: this.getSubLeaderLabel(cityid)},
      {code: "=MEMBER",label: "MEMBER"},
      {code: "=null",label: "NOT YET SPECIFIED"}
    ];
  },

  getRankedVoterTypesByCity(cityid){
    return [
      {code: "=G-LEADER",label: this.getGLeaderLabel(cityid)},
      {code: "=BOMTE",label: this.getPLeaderLabel(cityid)},
      {code: "=LEADER",label: this.getLeaderLabel(cityid)},
      {code: "=SUB-LEADER",label: this.getSubLeaderLabel(cityid)},
    ];
  },

  getLeaderLabel(cityid) {
    switch (cityid) {
      case 4:
        return "POMTE";
      case 2:
      case 2001:
        return "SUB-LEADER";
      case 1001:
        return "SITIO LEADER";
      case 1003:
          return "SUB-LEADER";
      case 1005:
          return "SITIO LEADER";
      case 6:
          return "PRECINCT MANAGER";
      case 5:
          return "PL"; 
      case 3:
      case 7:
        return "PUROK LEADER";
      default:
        return "LEADER";
    }
  },

  getSubLeaderLabel(cityid) {
    switch (cityid) {
      case 4:
      case 7:
        return "A1";
      case 6:
        return "GROUP LEADER";
      case 5:
        return "HL"; 
      case 2:
        return "HHL";
      case 2001:
        return "COORDINATOR";  
      case 3:
      case 1001:
      case 1005:
        return "FAMILY LEADER";
      case 1003:
          return "HoF";
      default:
        return "SUB-LEADER";
    }
  },

  getNonSupporterTerm(cityid) {
    switch (cityid) {
      case 4:
        return "ODT";
      case 7:
        return "MDT";
      case 6:
        return "MDT";
      case 3:
        return "OPPOSITION";
      case 1:
        return "PDT";
      case 1004:
        return "P";
      default:
        return "NON-SUPPORTER";
    }
  },

  highlightMatchingText(source, text) {
    if (!source || !text) return text;
    const regex = new RegExp(`(${source})`, "gi");
    // Replace matching text with <strong> tags
    const highlightedText = text.replace(regex, "<strong>$1</strong>");
    return DOMPurify.sanitize(highlightedText);
  },
  getFullDateTimeFormat(){
    const currentDateTime = new Date();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    return currentDateTime.toLocaleString("en-US", options);
  },
  getGeoTaggingSupporterLabel(id){
    switch(id){
      case 4:
        return "Validated Red Voters";
      default:
        return "Total Supporters"
    }
  },

async generateQRCodeBase64(text) {
  try {
    const base64String = await QRCode.toDataURL(text);
    return base64String;
  } catch (err) {
    console.error('QR generation error:', err);
    return null;
  }
}

// Usage example:
// const qrImage = await generateQRCodeBase64('Your text here');
}

export default customizationService;